import { requestWithAuth } from './api';

const PROFILE_URL = '/core/v1/Profiles/me/full';

/**
 * Busca o perfil completo do usuário logado
 * @param {boolean} useCache - Se deve usar cache do backend (default: true)
 * @returns {Promise<Object>} Dados completos do perfil
 */
export async function getProfile(useCache = true) {
  const response = await requestWithAuth(PROFILE_URL, {}, {
    'PTM-USE-CACHE': useCache.toString()
  });

  if (!response || !response.ok) {
    throw new Error('Erro ao buscar o perfil do usuário');
  }

  return await response.json();
}

/**
 * Força refresh do perfil sem cache
 * Útil para verificar alterações de permissão em tempo real
 * @returns {Promise<Object>} Dados atualizados do perfil
 */
export async function refreshProfile() {
  return getProfile(false);
}

/**
 * Extrai informações de admin level do perfil
 * @param {Object} profile - Objeto de perfil retornado pelo backend
 * @returns {Object} { adminLevel, adminLevelName }
 */
export function extractAdminLevelFromProfile(profile) {
  return {
    adminLevel: profile?.admin_level ?? profile?.profile_role_level ?? 0,
    adminLevelName: profile?.admin_level_name ?? profile?.profile_role_level_name ?? ''
  };
}

